module.exports = __webpack_public_path__ + "static/media/innopay.5e8bbff8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/innopay.svg
// module id = 384
// module chunks = 7